<template>
  <div>
    <v-card>
      <v-row>
        <v-col>
          <v-card-title>Salary Increment Import</v-card-title>
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        />

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                href="/templates/Salary Increment Import.xlsx"
                color="hrissuccess"
                dark
                icon
                medium
                v-on="{ ...tooltip }"
              >
                <v-icon class="mr-1">
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Salary Increment Import Template</span>
          </v-tooltip>

          <import-payroll-dialog-import />
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    components: {
      ImportPayrollDialogImport: () => import('@/components/hris/import/payroll/DialogImport'),
    },
  }
</script>
